export default __webpack_public_path__ + "static/media/twitter_alt.72e2e1fd.svg";